import { FUNNEL_TYPES } from "../components/funnel/utils/contants";
import { Release, ReleasePricingType } from "../types";
import { useReleasePricingInfo } from "./useReleasePricingInfo";

export function usePaywallType(release?: Release) {
  const pricingInfo = useReleasePricingInfo(release);

  switch (pricingInfo?.type) {
    case ReleasePricingType.FreeWithGold:
      return FUNNEL_TYPES.subscription;
    case ReleasePricingType.GoldDiscount:
    case ReleasePricingType.OnSaleAndAvailableGoldDiscount:
    case ReleasePricingType.OnGoldSale:
    case ReleasePricingType.OnSale:
    case ReleasePricingType.OnSaleWithGoldDiscount:
    case ReleasePricingType.Regular:
      return FUNNEL_TYPES.purchaseRelease;
    default:
      return FUNNEL_TYPES.prePaywall;
  }
}
